// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%2366bf01%27 fill-opacity=%270.05%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Loans Page – Modern & Engaging Layout === */

:root {
  --brand-primary: #66BF01;
  --brand-primary-light: rgba(102, 191, 1, 0.1);
  --brand-dark: #26303D;
  --brand-gradient: linear-gradient(135deg, var(--brand-primary), #4F8A10);

  --text-primary: #1F2937;
  --text-secondary: #4B5563;
  --text-muted: #6B7280;

  --white: #ffffff;
  --off-white: #F9FAFB;
  --light-gray: #F3F4F6;

  --border-color: #E5E7EB;
  --border-radius: 16px;
  --border-radius-lg: 24px;

  --shadow-sm: 0 1px 3px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03);
  --shadow-lg: 0 10px 25px -5px rgba(0,0,0,0.08), 0 8px 10px -6px rgba(0,0,0,0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);

  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  background: var(--white);
  color: var(--text-primary);
  line-height: 1.6;
}

/* ===========================
   GLOBAL STYLES
=========================== */

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  color: var(--brand-dark);
}

p {
  margin-bottom: 1.25rem;
  color: var(--text-secondary);
}

a {
  color: var(--brand-primary);
  text-decoration: none;
  transition: var(--transition);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5;
  transition: var(--transition);
  cursor: pointer;
  border: none;
  text-align: center;
  white-space: nowrap;
}

.btn-primary {
  background: var(--brand-gradient);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 191, 1, 0.25);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 191, 1, 0.35);
}

.btn-secondary {
  background: #fff;
  color: #66BF01;
  border: 3px solid #66BF01;
  font-weight: 700;
  text-align: center;
}

.btn-secondary:hover {
  background: var(--brand-primary-light);
  transform: translateY(-2px);
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: var(--brand-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.section-title p {
  font-size: 1.125rem;
  color: var(--text-secondary);
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

/* ===========================
   LOANS PAGE LAYOUT
=========================== */

.loans-page {
  overflow-x: hidden;
    padding-top: 50px; /* Increased from 80px to 90px for better spacing */

}

.loan-card h3 {
  color: white;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}
.loan-card p {
  color: rgba(255,255,255,0.9);
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}
.loan-card .interest {
  background: rgba(255,255,255,0.2);
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

/* Services Tabs */
.services-tabs {
  padding: 5rem 0;
  background: var(--off-white);
  position: relative;
  z-index: 1;
}

.services-tabs::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 300px;
  background: linear-gradient(180deg, white 0%, rgba(255,255,255,0) 100%);
  z-index: -1;
}

.tabs-header {
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  background: white;
  padding: 0.5rem;
  border-radius: 50px;
  max-width: 500px;
}

.tab-btn {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  border-radius: 50px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.tab-btn.active {
  background: var(--brand-gradient);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 191, 1, 0.25);
  transform: translateY(-1px);
}

.tab-btn:not(.active):hover {
  background: rgba(0,0,0,0.03);
  color: var(--text-color);
}

.tab-content {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.service-card {
  background: white;
  border-radius: var(--border-radius);
  padding: 2rem;
  transition: var(--transition);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--brand-gradient);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
}

.service-card:hover::before {
  transform: scaleX(1);
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--brand-primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: var(--brand-primary);
  font-size: 1.5rem;
  transition: var(--transition);
}

.service-card:hover .card-icon {
  background: var(--brand-gradient);
  color: white;
  transform: scale(1.1) rotate(5deg);
}

.service-card h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  color: var(--brand-dark);
}

.service-card p {
  color: var(--text-secondary);
  margin-bottom: 1.25rem;
  flex-grow: 1;
}

.card-features {
  list-style: none;
  margin: 1.5rem 0;
  padding: 0;
}

.card-features li {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.card-features svg {
  margin-right: 0.5rem;
  color: var(--brand-primary);
  flex-shrink: 0;
}

.card-cta {
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

/* Service Card Styles */
.service-card {
  background: white;
  border-radius: 12px;
  padding: 1.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.service-card .card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  background: linear-gradient(135deg, rgba(102, 191, 1, 0.1) 0%, rgba(102, 191, 1, 0.2) 100%);
  color: var(--brand-primary);
}

.service-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: var(--text-dark);
}

.service-card p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--text-muted);
  margin-bottom: 1.25rem;
}

.card-features {
  margin: 0 0 1.5rem 0;
  padding: 0;
  list-style: none;
}

.card-features li {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: var(--text-muted);
}

.card-features svg {
  margin-right: 0.5rem;
  color: var(--brand-primary);
  flex-shrink: 0;
}

.card-cta {
  margin-top: auto;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-light);
  width: 100%;
}

/* Button Styles */
.apply-btn, .learn-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  width: 100%;
  text-align: center;
  cursor: pointer !important;
}

/* Ensure links are properly styled */
.service-card .apply-btn,
.service-card .learn-btn {
  cursor: pointer !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  pointer-events: auto !important;
  position: relative !important;
  z-index: 10 !important;
}

.apply-btn {
  background: var(--brand-gradient);
  color: white !important;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(102, 191, 1, 0.3);
}

.apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 191, 1, 0.4);
  background: linear-gradient(135deg, #5aa801 0%, #3a7a0a 100%);
}

.learn-btn {
  color: var(--brand-primary);
  font-weight: 600;
  background: transparent;
  border: 1px solid var(--border-light);
  cursor: pointer !important;
}

.learn-btn:hover {
  background: rgba(102, 191, 1, 0.05);
  border-color: rgba(102, 191, 1, 0.2);
}

.learn-btn span {
  margin-left: 0.25rem;
  transition: transform 0.3s ease;
}

.learn-btn:hover span {
  transform: translateX(3px);
}

/* CTA Section */
.loans-cta {
  padding: 5rem 0;
  background: linear-gradient(135deg, rgba(102, 191, 1, 0.05) 0%, rgba(79, 138, 16, 0.05) 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.loans-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
  z-index: 0;
}

.cta-content {
  position: relative;
  z-index: 1;
  max-width: 700px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: 2.25rem;
  margin-bottom: 1rem;
  color: var(--brand-dark);
}

.cta-content p {
  font-size: 1.125rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
  
  .section-title h2 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .services-tabs {
    padding: 3rem 0;
  }
  
  .tabs-header {
    max-width: 100%;
  }
  
  .tab-btn {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
  
  .service-card {
    padding: 1.5rem;
  }
  
  .loans-cta {
    padding: 4rem 1.5rem;
  }
  
  .cta-content h2 {
    font-size: 1.75rem;
  }
  
  .cta-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .btn {
    width: 100%;
  }
}

/* Animations */
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Utility Classes */
.text-center { text-align: center; }
.mb-0 { margin-bottom: 0 !important; }
.mt-0 { margin-top: 0 !important; }

/* ===========================
   VERTICAL TABS
=========================== */

.tabs-container.vertical {
  margin-top: 1.5rem;
  background: var(--off-white);
  max-width: 320px;
  padding: 0.5rem;
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  box-shadow: var(--shadow-sm);
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  border: none;
  background: transparent;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: var(--transition);
}

.tab-btn:hover {
  color: var(--brand-primary);
}

.tab-btn.active {
  background: var(--brand-primary);
  color: white;
  box-shadow: 0 6px 20px rgba(102,191,1,0.35);
}

/* ===========================
   RIGHT CARDS AREA
=========================== */

.services-cards {
  width: 100%;
}

/* Masonry grid */
.services-grid.masonry {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 1.75rem;
}

/* Staggered offsets */
.services-grid.masonry .service-card:nth-child(2),
.services-grid.masonry .service-card:nth-child(4) {
  margin-top: 2.25rem;
}

/* ===========================
   SERVICE CARD
=========================== */

.service-card {
  position: relative;
  background: var(--white);
  border-radius: var(--radius-lg);
  padding: 1.75rem;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  overflow: hidden;
}

.service-card.primary {
  border-top: 4px solid var(--brand-primary);
}

.service-card.secondary {
  background: #F9FAFB;
  border-top: 4px solid var(--brand-dark);
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
}

/* Soft light sweep */
.service-card::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(
    120deg,
    rgba(255,255,255,0.25),
    transparent 40%
  );
  opacity: 0;
  transition: var(--transition);
}

.service-card:hover::after {
  opacity: 1;
}

.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* ===========================
   ICON
=========================== */

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--brand-primary), #4F8A10);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  box-shadow: 0 8px 18px rgba(0,0,0,0.15);
}

.service-card.secondary .card-icon {
  background: linear-gradient(135deg, var(--brand-dark), #1E293B);
}

/* ===========================
   CARD TEXT
=========================== */

.service-card h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.service-card p {
  font-size: 0.95rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

/* Features */
.service-card ul {
  margin-bottom: auto;
}

.service-card li {
  font-size: 0.85rem;
  display: flex;
  gap: 0.5rem;
}

/* Learn more */
.service-card a {
  margin-top: 1.25rem;
  font-weight: 600;
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ===========================
   CTA SECTION
=========================== */

.cta-section {
  margin: 5rem 0 3rem;
  padding: 4rem 2rem;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, var(--brand-dark), #1E293B);
  color: white;
  text-align: center;
  box-shadow: var(--shadow-lg);
}

.cta-badge {
  display: inline-block;
  background: var(--brand-primary);
  padding: 0.5rem 1.25rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 800;
  margin-bottom: 1rem;
}

.cta-section h2 {
  font-size: 2.25rem;
  margin-bottom: 1rem;
}

.cta-description {
  max-width: 600px;
  margin: 0 auto 2rem;
  color: #CBD5E1;
}

/* Default CTA buttons alignment */
.cta-buttons {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  margin-left: 0;
  padding-left: 0;
  width: 100%;
  max-width: 100%;
}

/* Center align CTA buttons in the loans-cta section */
.loans-cta .cta-buttons {
  justify-content: center;
  margin: 0 auto;
  padding: 0;
}

/* ===========================
   RESPONSIVE
=========================== */

@media (max-width: 900px) {
  .tabs-header {
    flex-direction: column;
    border-radius: 12px;
    gap: 4px;
  }
  
  .tab-btn {
    border-radius: 8px;
    padding: 0.75rem 1rem;
  }

  .services-layout {
    grid-template-columns: 1fr;
  }

  .services-intro {
    position: static;
    align-items: center;
    text-align: center;
  }

  .services-intro p {
    max-width: 100%;
  }

  .tabs-container.vertical {
    flex-direction: row;
  }

  .services-grid.masonry {
    grid-template-columns: 1fr;
  }

  .services-grid.masonry .service-card {
    margin-top: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/loans.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAGlD;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,qBAAqB;EACrB,wEAAwE;;EAExE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;;EAErB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;;EAExB,uCAAuC;EACvC,6EAA6E;EAC7E,gFAAgF;EAChF,gFAAgF;;EAEhF,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;6BAE6B;;AAE7B;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;6BAE6B;;AAE7B;EACE,kBAAkB;IAChB,iBAAiB,EAAE,mDAAmD;;AAE1E;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,YAAY;EACZ,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uEAAuE;EACvE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2FAA2F;EAC3F,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;;EAEE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,6FAA6F;EAC7F,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mDAA8X;EAC9X,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,4BAA4B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,oBAAoB;AACpB,eAAe,kBAAkB,EAAE;AACnC,QAAQ,2BAA2B,EAAE;AACrC,QAAQ,wBAAwB,EAAE;;AAElC;;6BAE6B;;AAE7B;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;;6BAE6B;;AAE7B;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,oDAAoD;EACpD,YAAY;AACd;;AAEA,sBAAsB;AACtB;;EAEE,mBAAmB;AACrB;;AAEA;;6BAE6B;;AAE7B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB;;;;GAIC;EACD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;6BAE6B;;AAE7B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kEAAkE;EAClE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;6BAE6B;;AAE7B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;6BAE6B;;AAE7B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,+DAA+D;EAC/D,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;;6BAE6B;;AAE7B;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* === Loans Page – Modern & Engaging Layout === */\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --brand-primary: #66BF01;\n  --brand-primary-light: rgba(102, 191, 1, 0.1);\n  --brand-dark: #26303D;\n  --brand-gradient: linear-gradient(135deg, var(--brand-primary), #4F8A10);\n\n  --text-primary: #1F2937;\n  --text-secondary: #4B5563;\n  --text-muted: #6B7280;\n\n  --white: #ffffff;\n  --off-white: #F9FAFB;\n  --light-gray: #F3F4F6;\n\n  --border-color: #E5E7EB;\n  --border-radius: 16px;\n  --border-radius-lg: 24px;\n\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.04);\n  --shadow-md: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03);\n  --shadow-lg: 0 10px 25px -5px rgba(0,0,0,0.08), 0 8px 10px -6px rgba(0,0,0,0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);\n\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;\n  background: var(--white);\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\n/* ===========================\n   GLOBAL STYLES\n=========================== */\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 1rem;\n  color: var(--brand-dark);\n}\n\np {\n  margin-bottom: 1.25rem;\n  color: var(--text-secondary);\n}\n\na {\n  color: var(--brand-primary);\n  text-decoration: none;\n  transition: var(--transition);\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.875rem 1.75rem;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.5;\n  transition: var(--transition);\n  cursor: pointer;\n  border: none;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  background: var(--brand-gradient);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 191, 1, 0.25);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 191, 1, 0.35);\n}\n\n.btn-secondary {\n  background: #fff;\n  color: #66BF01;\n  border: 3px solid #66BF01;\n  font-weight: 700;\n  text-align: center;\n}\n\n.btn-secondary:hover {\n  background: var(--brand-primary-light);\n  transform: translateY(-2px);\n}\n\n.section-title {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.section-title h2 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  background: var(--brand-gradient);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n}\n\n.section-title p {\n  font-size: 1.125rem;\n  color: var(--text-secondary);\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ===========================\n   LOANS PAGE LAYOUT\n=========================== */\n\n.loans-page {\n  overflow-x: hidden;\n    padding-top: 50px; /* Increased from 80px to 90px for better spacing */\n\n}\n\n.loan-card h3 {\n  color: white;\n  text-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n.loan-card p {\n  color: rgba(255,255,255,0.9);\n  text-shadow: 0 1px 2px rgba(0,0,0,0.2);\n}\n.loan-card .interest {\n  background: rgba(255,255,255,0.2);\n  color: white;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.2);\n}\n\n/* Services Tabs */\n.services-tabs {\n  padding: 5rem 0;\n  background: var(--off-white);\n  position: relative;\n  z-index: 1;\n}\n\n.services-tabs::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 300px;\n  background: linear-gradient(180deg, white 0%, rgba(255,255,255,0) 100%);\n  z-index: -1;\n}\n\n.tabs-header {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 3rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 50px;\n  max-width: 500px;\n}\n\n.tab-btn {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 50px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.tab-btn.active {\n  background: var(--brand-gradient);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 191, 1, 0.25);\n  transform: translateY(-1px);\n}\n\n.tab-btn:not(.active):hover {\n  background: rgba(0,0,0,0.03);\n  color: var(--text-color);\n}\n\n.tab-content {\n  animation: fadeIn 0.5s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Services Grid */\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.service-card {\n  background: white;\n  border-radius: var(--border-radius);\n  padding: 2rem;\n  transition: var(--transition);\n  border: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n.service-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: var(--brand-gradient);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.4s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n}\n\n.service-card:hover::before {\n  transform: scaleX(1);\n}\n\n.card-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--brand-primary-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  color: var(--brand-primary);\n  font-size: 1.5rem;\n  transition: var(--transition);\n}\n\n.service-card:hover .card-icon {\n  background: var(--brand-gradient);\n  color: white;\n  transform: scale(1.1) rotate(5deg);\n}\n\n.service-card h3 {\n  font-size: 1.25rem;\n  margin-bottom: 0.75rem;\n  color: var(--brand-dark);\n}\n\n.service-card p {\n  color: var(--text-secondary);\n  margin-bottom: 1.25rem;\n  flex-grow: 1;\n}\n\n.card-features {\n  list-style: none;\n  margin: 1.5rem 0;\n  padding: 0;\n}\n\n.card-features li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.card-features svg {\n  margin-right: 0.5rem;\n  color: var(--brand-primary);\n  flex-shrink: 0;\n}\n\n.card-cta {\n  margin-top: auto;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-color);\n}\n\n/* Service Card Styles */\n.service-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.75rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.service-card .card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n  background: linear-gradient(135deg, rgba(102, 191, 1, 0.1) 0%, rgba(102, 191, 1, 0.2) 100%);\n  color: var(--brand-primary);\n}\n\n.service-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n  color: var(--text-dark);\n}\n\n.service-card p {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: var(--text-muted);\n  margin-bottom: 1.25rem;\n}\n\n.card-features {\n  margin: 0 0 1.5rem 0;\n  padding: 0;\n  list-style: none;\n}\n\n.card-features li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.card-features svg {\n  margin-right: 0.5rem;\n  color: var(--brand-primary);\n  flex-shrink: 0;\n}\n\n.card-cta {\n  margin-top: auto;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-light);\n  width: 100%;\n}\n\n/* Button Styles */\n.apply-btn, .learn-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.8rem 1.5rem;\n  border-radius: 50px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  width: 100%;\n  text-align: center;\n  cursor: pointer !important;\n}\n\n/* Ensure links are properly styled */\n.service-card .apply-btn,\n.service-card .learn-btn {\n  cursor: pointer !important;\n  text-decoration: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  pointer-events: auto !important;\n  position: relative !important;\n  z-index: 10 !important;\n}\n\n.apply-btn {\n  background: var(--brand-gradient);\n  color: white !important;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.5px;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(102, 191, 1, 0.3);\n}\n\n.apply-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 191, 1, 0.4);\n  background: linear-gradient(135deg, #5aa801 0%, #3a7a0a 100%);\n}\n\n.learn-btn {\n  color: var(--brand-primary);\n  font-weight: 600;\n  background: transparent;\n  border: 1px solid var(--border-light);\n  cursor: pointer !important;\n}\n\n.learn-btn:hover {\n  background: rgba(102, 191, 1, 0.05);\n  border-color: rgba(102, 191, 1, 0.2);\n}\n\n.learn-btn span {\n  margin-left: 0.25rem;\n  transition: transform 0.3s ease;\n}\n\n.learn-btn:hover span {\n  transform: translateX(3px);\n}\n\n/* CTA Section */\n.loans-cta {\n  padding: 5rem 0;\n  background: linear-gradient(135deg, rgba(102, 191, 1, 0.05) 0%, rgba(79, 138, 16, 0.05) 100%);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.loans-cta::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2366bf01' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  opacity: 0.3;\n  z-index: 0;\n}\n\n.cta-content {\n  position: relative;\n  z-index: 1;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.cta-content h2 {\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n  color: var(--brand-dark);\n}\n\n.cta-content p {\n  font-size: 1.125rem;\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .services-grid {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  }\n  \n  .section-title h2 {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-tabs {\n    padding: 3rem 0;\n  }\n  \n  .tabs-header {\n    max-width: 100%;\n  }\n  \n  .tab-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  }\n  \n  .service-card {\n    padding: 1.5rem;\n  }\n  \n  .loans-cta {\n    padding: 4rem 1.5rem;\n  }\n  \n  .cta-content h2 {\n    font-size: 1.75rem;\n  }\n  \n  .cta-buttons {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .btn {\n    width: 100%;\n  }\n}\n\n/* Animations */\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n  100% { transform: translateY(0px); }\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n/* Utility Classes */\n.text-center { text-align: center; }\n.mb-0 { margin-bottom: 0 !important; }\n.mt-0 { margin-top: 0 !important; }\n\n/* ===========================\n   VERTICAL TABS\n=========================== */\n\n.tabs-container.vertical {\n  margin-top: 1.5rem;\n  background: var(--off-white);\n  max-width: 320px;\n  padding: 0.5rem;\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.tab-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.tab-btn:hover {\n  color: var(--brand-primary);\n}\n\n.tab-btn.active {\n  background: var(--brand-primary);\n  color: white;\n  box-shadow: 0 6px 20px rgba(102,191,1,0.35);\n}\n\n/* ===========================\n   RIGHT CARDS AREA\n=========================== */\n\n.services-cards {\n  width: 100%;\n}\n\n/* Masonry grid */\n.services-grid.masonry {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(260px, 1fr));\n  gap: 1.75rem;\n}\n\n/* Staggered offsets */\n.services-grid.masonry .service-card:nth-child(2),\n.services-grid.masonry .service-card:nth-child(4) {\n  margin-top: 2.25rem;\n}\n\n/* ===========================\n   SERVICE CARD\n=========================== */\n\n.service-card {\n  position: relative;\n  background: var(--white);\n  border-radius: var(--radius-lg);\n  padding: 1.75rem;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  overflow: hidden;\n}\n\n.service-card.primary {\n  border-top: 4px solid var(--brand-primary);\n}\n\n.service-card.secondary {\n  background: #F9FAFB;\n  border-top: 4px solid var(--brand-dark);\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Soft light sweep */\n.service-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: linear-gradient(\n    120deg,\n    rgba(255,255,255,0.25),\n    transparent 40%\n  );\n  opacity: 0;\n  transition: var(--transition);\n}\n\n.service-card:hover::after {\n  opacity: 1;\n}\n\n.card-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* ===========================\n   ICON\n=========================== */\n\n.card-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, var(--brand-primary), #4F8A10);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n  box-shadow: 0 8px 18px rgba(0,0,0,0.15);\n}\n\n.service-card.secondary .card-icon {\n  background: linear-gradient(135deg, var(--brand-dark), #1E293B);\n}\n\n/* ===========================\n   CARD TEXT\n=========================== */\n\n.service-card h3 {\n  font-size: 1.25rem;\n  margin-bottom: 0.5rem;\n}\n\n.service-card p {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n}\n\n/* Features */\n.service-card ul {\n  margin-bottom: auto;\n}\n\n.service-card li {\n  font-size: 0.85rem;\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Learn more */\n.service-card a {\n  margin-top: 1.25rem;\n  font-weight: 600;\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* ===========================\n   CTA SECTION\n=========================== */\n\n.cta-section {\n  margin: 5rem 0 3rem;\n  padding: 4rem 2rem;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, var(--brand-dark), #1E293B);\n  color: white;\n  text-align: center;\n  box-shadow: var(--shadow-lg);\n}\n\n.cta-badge {\n  display: inline-block;\n  background: var(--brand-primary);\n  padding: 0.5rem 1.25rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 800;\n  margin-bottom: 1rem;\n}\n\n.cta-section h2 {\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n}\n\n.cta-description {\n  max-width: 600px;\n  margin: 0 auto 2rem;\n  color: #CBD5E1;\n}\n\n/* Default CTA buttons alignment */\n.cta-buttons {\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-left: 0;\n  padding-left: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Center align CTA buttons in the loans-cta section */\n.loans-cta .cta-buttons {\n  justify-content: center;\n  margin: 0 auto;\n  padding: 0;\n}\n\n/* ===========================\n   RESPONSIVE\n=========================== */\n\n@media (max-width: 900px) {\n  .tabs-header {\n    flex-direction: column;\n    border-radius: 12px;\n    gap: 4px;\n  }\n  \n  .tab-btn {\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n  }\n\n  .services-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .services-intro {\n    position: static;\n    align-items: center;\n    text-align: center;\n  }\n\n  .services-intro p {\n    max-width: 100%;\n  }\n\n  .tabs-container.vertical {\n    flex-direction: row;\n  }\n\n  .services-grid.masonry {\n    grid-template-columns: 1fr;\n  }\n\n  .services-grid.masonry .service-card {\n    margin-top: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
